import { useEffect, useState } from "react";
import { Loader2, Scale } from "lucide-react";
import { toast } from "sonner";
import { SectionLabel } from "@/components/Status";
import { useLang } from "@/i18n";
import { api, errCode } from "@/lib/api";

const FIELDS = ["operator_name", "operator_address", "operator_email", "operator_phone", "dpo_name", "dpo_email"];

export function OperatorForm({ index = "04" }) {
  const { t } = useLang();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/config").then((r) => setForm(r.data.operator || {})).catch(() => setForm({}));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.patch("/admin/legal-contacts", form);
      setForm(data);
      toast.success(t("admin.operatorSaved"));
    } catch (err) { toast.error(t(`errors.${errCode(err)}`, errCode(err))); } finally { setBusy(false); }
  };

  return (
    <section className="reveal reveal-4 mb-12" data-testid="admin-operator-section">
      <SectionLabel index={index}>{t("admin.operator")}</SectionLabel>
      <div className="panel p-6">
        <p className="mb-5 flex items-start gap-2 text-xs leading-relaxed text-vox-muted"><Scale size={14} className="mt-0.5 shrink-0 text-vox-accent" />{t("admin.operatorHint")}</p>
        {!form ? <Loader2 size={14} className="animate-spin text-vox-dim" /> : (
          <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
            {FIELDS.map((k) => (
              <div key={k} className={k === "operator_address" ? "sm:col-span-2" : ""}>
                <label className="mono-label mb-2 block" htmlFor={`op-${k}`}>{t(`admin.${k}`)}</label>
                <input id={`op-${k}`} className="input" value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`operator-${k.replaceAll("_", "-")}-input`} />
              </div>
            ))}
            <div className="sm:col-span-2">
              <button type="submit" disabled={busy} className="btn-primary" data-testid="operator-save-button">{busy ? <Loader2 size={14} className="animate-spin" /> : null} {t("common.save")}</button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
